import { Alert, CollapseProps, Table, Typography } from 'antd'

const { Text } = Typography

const headerFields = [
    { field: 'Клиент', meaning: 'Кому продаём' },
    { field: 'Менеджер', meaning: 'Кто ведёт заказ' },
    { field: 'Статус', meaning: 'Где заказ находится в жизненном цикле' },
    {
        field: 'Срок',
        meaning: 'Дата, обещанная клиенту по всему заказу (не срок отдельной позиции)',
    },
    { field: 'Условия оплаты', meaning: 'Предоплата, постоплата или отсрочка (с числом дней)' },
    { field: 'Скидка, %', meaning: 'Скидка на весь заказ' },
    { field: 'Дата подтверждения', meaning: 'Когда клиент подтвердил заказ' },
]

const productTypes = [
    {
        type: 'Этикетка',
        source: 'Отгрузка, созданная из расчёта',
        name: 'Название этикетки из позиции отгрузки',
        quantity: 'Тираж, шт',
        price: 'Доля стоимости отгрузки пропорционально тиражу этой этикетки',
    },
    {
        type: 'Цветопроба',
        source: 'Отгрузка с типом «цветопроба»',
        name: 'Как у этикетки',
        quantity: 'Как у этикетки',
        price: 'Как у этикетки',
    },
    {
        type: 'Риббон',
        source: 'Раздел «Риббоны»',
        name: '«Риббон»',
        quantity: 'Число рулонов',
        price: 'Отпускная цена рулона × число рулонов',
    },
    {
        type: 'Штамп',
        source: 'Штамп вынесен из себестоимости тиража',
        name: '«Штамп № …»',
        quantity: '1',
        price: 'Стоимость штампа',
    },
    {
        type: 'Флексоформы',
        source: 'Формы вынесены из себестоимости тиража',
        name: '«Флексоформы»',
        quantity: '1',
        price: 'Стоимость комплекта форм',
    },
    {
        type: 'Любой другой тип',
        source: '—',
        name: 'Из самой позиции',
        quantity: 'Из самой позиции',
        price: 'Согласованная цена позиции',
    },
]

export const helpItems: CollapseProps['items'] = [
    {
        key: '1',
        label: <b>Заказ</b>,
        children: (
            <>
                <p>
                    Заказ — это одна коммерческая сделка с клиентом: что мы ему продаём, на каких
                    условиях и к какому сроку. Раздел «Заказы» доступен менеджерам, помощникам
                    менеджеров и супер-админу; каждый менеджер видит только свои заказы.
                </p>
                <p>В шапке заказа задаются условия на весь заказ целиком:</p>
                <Table
                    size='small'
                    pagination={false}
                    rowKey='field'
                    dataSource={headerFields}
                    columns={[
                        { title: 'Поле', dataIndex: 'field', width: 200 },
                        { title: 'Что означает', dataIndex: 'meaning' },
                    ]}
                />
                <p style={{ marginTop: 16 }}>
                    Статусы заказа: Черновик → Ожидает согласования → Подтверждён → В производстве →
                    Частично отгружен → Отгружен → Закрыт. Первые четыре статуса считаются
                    «открытыми»: только в такой заказ система предлагает добавить новую продукцию.
                </p>
            </>
        ),
    },
    {
        key: '2',
        label: <b>Позиции заказа</b>,
        children: (
            <>
                <p>
                    Позиция — одна строка заказа, то есть один продукт, который мы продаём клиенту.
                    В одном заказе может быть сколько угодно позиций разных типов: например, две
                    этикетки, штамп, риббон и коробка.
                </p>
                <p>У каждой позиции есть:</p>
                <ul>
                    <li>
                        <Text strong>Тип продукции</Text> — что именно продаём (этикетка, штамп,
                        риббон и т.д.)
                    </li>
                    <li>
                        <Text strong>Наименование, количество, единица</Text> — шт, м, м², кг,
                        комплект, км или рулон
                    </li>
                    <li>
                        <Text strong>Цена</Text> — согласованная с клиентом цена строки
                    </li>
                    <li>
                        <Text strong>Срок производства</Text> — внутренний план готовности именно
                        этой позиции
                    </li>
                    <li>
                        <Text strong>Статус позиции</Text> — Черновик → Рассчитана → Согласована → В
                        производстве → Отгружена; он ведётся отдельно от статуса заказа
                    </li>
                </ul>
                <p>
                    В карточке заказа позиции пока только просматриваются: руками их не добавляют.
                    Позиция появляется сама, когда менеджер создаёт продукцию в своём разделе
                    (отгрузку, риббон) или выносит оснастку из себестоимости. При этом система ищет
                    открытые заказы клиента:
                </p>
                <ul>
                    <li>нет открытых — создаётся новый заказ;</li>
                    <li>
                        один — вопрос «Добавить в существующий заказ № N?» (Да / Нет, создать
                        новый);
                    </li>
                    <li>несколько — выбор заказа из списка или создание нового.</li>
                </ul>
            </>
        ),
    },
    {
        key: '3',
        label: <b>Связь позиций с типами продукции</b>,
        children: (
            <>
                <p>
                    Тип продукции определяет, откуда позиция берёт наименование, количество и цену.
                    Позиция не хранит эти данные «сама по себе», а ссылается на исходный документ в
                    другом разделе системы. Поэтому если изменить отгрузку или риббон, строка заказа
                    покажет актуальные цифры.
                </p>
                <Table
                    size='small'
                    pagination={false}
                    rowKey='type'
                    dataSource={productTypes}
                    columns={[
                        { title: 'Тип продукции', dataIndex: 'type' },
                        { title: 'Откуда появляется позиция', dataIndex: 'source' },
                        { title: 'Наименование', dataIndex: 'name' },
                        { title: 'Количество', dataIndex: 'quantity' },
                        { title: 'Цена', dataIndex: 'price' },
                    ]}
                />
                <p style={{ marginTop: 16 }}>
                    Пример цены этикетки: отгрузка стоит 100 000 ₽, в ней две этикетки тиражом 30
                    000 и 10 000 шт. В заказе первая получит 75 000 ₽, вторая — 25 000 ₽. Если у
                    отгрузки ещё нет стоимости, цена в строке пустая, а не ноль.
                </p>
                <Alert
                    showIcon
                    type='info'
                    message='Штамп и флексоформы — это оснастка. По умолчанию их стоимость входит в себестоимость тиража, и отдельной строки в заказе нет. Если на отгрузке снять галочку «Включено в себестоимость», в заказе появляется отдельная строка штампа или форм; если вернуть галочку — строка удаляется.'
                />
            </>
        ),
    },
    {
        key: '4',
        label: <b>Частые вопросы</b>,
        children: (
            <>
                <p>
                    <Text strong>Почему я не могу добавить позицию прямо в заказе?</Text> Позиция —
                    следствие работы в других разделах. Чтобы добавить этикетку, создайте отгрузку
                    из расчёта; риббон — в разделе «Риббоны».
                </p>
                <p>
                    <Text strong>Почему цена в строке изменилась?</Text> Изменился исходный
                    документ: стоимость отгрузки, тираж, цена рулона или стоимость оснастки. Строка
                    заказа всегда показывает актуальную цифру.
                </p>
                <p>
                    <Text strong>Почему галочку оснастки нельзя снять?</Text> Так бывает, если у
                    отгрузки нет заказа, она уже спущена в печать или штамп виртуальный. При нулевой
                    стоимости оснастки отдельная строка не создаётся.
                </p>
                <p>
                    <Text strong>Почему я не вижу заказ коллеги?</Text> В разделе показываются
                    только заказы, где вы — менеджер.
                </p>
            </>
        ),
    },
]
